export class TableFilteringOperators<T extends Record<string, any>> {
    private search: string;

    constructor(searchText: string) {
        this.search = searchText?.toLowerCase() ?? '';
    }

    private matchField(row: T, field: keyof T): boolean {
        const value = row[field];
        return typeof value === 'string' && value.toLowerCase().includes(this.search);
    }

    matchFirstName(row: T): boolean {
        return this.matchField(row, 'firstName');
    }

    matchLastName(row: T): boolean {
        return this.matchField(row, 'lastName');
    }

    matchPersonName(row: T): boolean {
        return this.matchField(row, 'personName');
    }

    matchBusinessName(row: T): boolean {
        return this.matchField(row, 'businessName');
    }

    filterRows(rows: T[]): T[] {
        if (!this.search) return rows;

        return rows.filter(
            (row) =>
                this.matchFirstName(row) || this.matchLastName(row) || this.matchPersonName(row) || this.matchBusinessName(row)
        );
    }
}
